/**
 * Backward compatibility - Re-export useApi as useApiService
 * @deprecated Use { useApi } from 'shared/hooks' instead
 */

import { useApi } from '../shared/hooks/useApi';

export default useApi;
